// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-ProductDetails__wrapper","content":"c-ProductDetails__content","button":"c-ProductDetails__button","image":"c-ProductDetails__image","header":"c-ProductDetails__header","description":"c-ProductDetails__description","price":"c-ProductDetails__price","priceValue":"c-ProductDetails__priceValue","beforeDiscount":"c-ProductDetails__beforeDiscount","quantity":"c-ProductDetails__quantity","buttonsWrapper":"c-ProductDetails__buttonsWrapper","buttons":"c-ProductDetails__buttons","quantityButtons":"c-ProductDetails__quantityButtons","removeButton":"c-ProductDetails__removeButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/ProductDetails/ProductDetails.scss
// module id = 513
// module chunks = 0